import {EntityModel} from '../../../core/model/entity.model';

export class JobPosition extends EntityModel {
  public name?: string;
  public active?: boolean;
  public salaryMin?: number;
  public salaryMax?: number;
}
